<ng-container *ngIf="formElements || form" [formGroup]="form">
  <ng-container [formArrayName]="formElements.formArrayName" *ngFor="let element of form.get(formElements.formArrayName)['controls']; let i = index;">
    <form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed" [formGroupName]="i">
      <div class="m-portlet__body">
        <div class="form-group m-form__group row" style="padding-top: 0% !important;padding-bottom: 0% !important;">
          <ng-container *ngFor="let rawElement of formElements.elements; let j = index;">
            <ng-container [ngSwitch]="rawElement.control.field.controlType">
              <label [class]="getLabelClass(rawElement.control.label.width)" [hidden]="(fieldInputOptions[i] && fieldInputOptions[i].hide && (j === fieldInputOptions[i].eleIndex)) ? true: null">
                {{rawElement.control.label.name}}<span style="color: red" *ngIf="rawElement.control.label.asterick">*</span>
              </label>
              <div [class]="getFieldClass(rawElement.control.field.width)" style="margin-bottom:25px;" [hidden]="(fieldInputOptions[i] && fieldInputOptions[i].hide && (j === fieldInputOptions[i].eleIndex)) ? true: null">
                <!-- TextBox -->
                <input *ngSwitchCase="'textbox'" [maxlength]="rawElement.control.field.maxLength" type="text" class="form-control m-input"
                  [placeholder]="rawElement.control.field.placeholder" [formControlName]="rawElement.key" (change)="onDataChange(i, j)">
                <!--Number TextBox-->
                <!-- (keydown)="onKeyDown($event, i, j, rawElement.key)"  -->
                <input *ngSwitchCase="'number'" [maxlength]="rawElement.control.field.maxLength" type="text" class="form-control m-input"
                  [placeholder]="rawElement.control.field.placeholder" [formControlName]="rawElement.key"
                  (change)="onNumberDataChange($event,rawElement.key, i, j)">
                   <!-- -->
                <!-- TextArea -->
                <textarea *ngSwitchCase="'textarea'" class="form-control m-input" rows="3" [placeholder]="rawElement.control.field.placeholder"
                  [formControlName]="rawElement.key" (change)="onDataChange(i, j)"></textarea>
                <!-- Radio -->
                <div *ngSwitchCase="'radio'" class="m-radio-inline">
                  <label class="m-radio" *ngFor="let opt of rawElement.control.field.dataOptions">
                    <input type="radio" [formControlName]="rawElement.key" [name]="rawElement.key" [value]="opt"
                      (change)="onDataChange(i, j)">
                    {{opt}}
                    <span></span>
                  </label>
                </div>
                <!-- Dropdown -->
                <select class="form-control m-input m-input--square" *ngSwitchCase="'select'" [id]="rawElement.key"
                  [formControlName]="rawElement.key" (change)="onDataChange(i, j)">
                  <option value="" selected disabled>{{rawElement.control.field.placeholder}}</option>
                  <option *ngFor="let opt of getDropDownArray(i, rawElement.key)" [value]="opt[rawElement.control.field.optionValue]">
                    {{opt[rawElement.control.field.optionKey]}}
                  </option>
                </select>
                <!-- CheckBox -->
                <div class="form-group m-form__group row" style="padding-top: 10px;" *ngSwitchCase="'checkbox'" [formGroupName]="rawElement.key">
                  <div class="col-lg-6" *ngFor="let opt of rawElement.control.field.dataOptions; let c = index" [hidden]="isCheckboxHidden(opt, c, i)">
                   <label class="m-checkbox">
                    <input type="checkbox" [formControlName]="opt.key" [value]="opt.value" (change)="onDataChange(i, j, true, c, $event)">
                    {{opt.label}}
                    <span></span>
                  </label>
                  </div>
                </div>
                <!-- <div class="m-checkbox-inline" >
                  <label class="m-checkbox" *ngFor="let opt of rawElement.control.field.dataOptions">
                    <input type="checkbox" [formControlName]="opt.key" [value]="opt.value" (change)="onDataChange(i, j, true)">
                    {{opt.label}}
                    <span></span>
                  </label>
                </div> -->
                <!--File-->
                <app-file-upload *ngSwitchCase="'file'" [multiColumn]="8" [fileValidation]="documentUpload[i][j]"
                  (fileUploaded)="onFileUploaded($event, i, j)" (fileUploadCancelled)="onFileUploadCancel($event, i, j )"></app-file-upload>
                <!--Date-->
                <ng-container *ngSwitchCase="'date'">
                  <app-date-picker [dateId]="rawElement.control.field.dateValidation" [model]="dateObject[i][j]"
                    (dateChanged)="onDateChange($event, i, j)"></app-date-picker>
                </ng-container>
                <span class="m-form__help">
                  <app-form-control-messages *ngIf="rawElement.control.field.errorMessage" [control]="element.get(rawElement.key)"
					[name]="rawElement.control.field.errorMessage.name" [message]="rawElement.control.field.errorMessage.message"></app-form-control-messages>
					<!-- <button *ngIf="rawElement.control.field.controlType === 'checkbox'" (click)="checkedCount(i, j)">Test</button> -->
					<span  style="color: red" *ngIf="toReturn && checkedCount(i, j)">
						Atleast {{rawElement.control.field.atleastRequired}} {{rawElement.control.label.name}} is required
					</span>
                </span>
              </div>
            </ng-container>
          </ng-container>
        </div>
        <div class="form-group m-form__group row" style="padding-top: 0% !important;">
          <div [class]="getClass('div')"></div>
          <div [class]="getClass('remove')" *ngIf="formElements.removeButton && form.value[formElements.formArrayName].length > 1">
            <button [class]="formElements.removeButton.btnClass" (click)="removeElement(i)">{{
              formElements.removeButton.text }}</button>
          </div>
          <div [class]="getClass('add')" *ngIf="i === form.value[formElements.formArrayName].length - 1">
            <button *ngIf="formElements.addmoreButton" [class]="formElements.addmoreButton.btnClass" [disabled]="element.invalid || addMoreElementInvalid"
              (click)="addElement()">{{
              formElements.addmoreButton.text }}</button>
          </div>
        </div>
      </div>
    </form>
  </ng-container>
</ng-container>
<div appSweetAlert></div>
